export default "__VITE_ASSET__9db5793e__"